import { render, staticRenderFns } from "./Identity.vue?vue&type=template&id=122a8d9a&scoped=true"
import script from "./Identity.vue?vue&type=script&lang=ts"
export * from "./Identity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122a8d9a",
  null
  
)

export default component.exports